import { gql } from '@apollo/client';

export const ALL_FREQUENCIES = gql`
  query AllFrequencies($typeId: ID) {
    frequencies: getFrequency(typeId: $typeId) {
      id
      name
    }
  }
`;
